var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 0.185547C13.128 0.185547 12.3073 1.00625 12.3073 2.01888C12.3073 3.03151 13.128 3.85221 14.1406 3.85221C15.1533 3.85221 15.974 3.03151 15.974 2.01888C15.974 1.00625 15.1518 0.185547 14.1406 0.185547ZM13.4589 4.67435L8.90703 8.46992C8.24273 9.02221 7.20719 9.02193 6.54461 8.47037L1.76562 4.48815V3.85221C1.76562 3.5995 1.97124 3.39388 2.22396 3.39388H11.7716C11.5367 2.98797 11.3906 2.52247 11.3906 2.01888H2.22396C1.21133 2.01888 0.390625 2.83958 0.390625 3.85221V11.1855C0.390625 12.1982 1.21133 13.0189 2.22396 13.0189H13.224C14.2366 13.0189 15.0573 12.1982 15.0573 11.1855V4.59987C14.768 4.70299 14.4643 4.76888 14.1406 4.76888C13.9029 4.76888 13.6794 4.72878 13.4589 4.67435ZM13.6823 11.1855C13.6823 11.4383 13.4767 11.6439 13.224 11.6439H2.22396C1.97124 11.6439 1.76562 11.4383 1.76562 11.1855V6.27852L5.66432 9.52695C6.24297 10.0053 6.97344 10.2689 7.72396 10.2689C8.47448 10.2689 9.20638 10.0058 9.7856 9.52466L13.6823 6.27852V11.1855Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxDot);
export default __webpack_public_path__ + "static/media/inbox-dot.674cda98b3cc32ab9cc490e68a64b761.svg";
export { ForwardRef as ReactComponent };